import { createContext, useContext } from 'react';

export type ApiSection = 'default' | 'mmb';

/**
 * A temporary context to specify which section of the app is making API calls.
 * This allows hooks to use different feature flags for different sections.
 * - 'default': Uses `feature-api-gateway` flag
 * - 'mmb': Uses `feature-api-gateway-mmb` flag
 */
export const ApiSectionContext = createContext<ApiSection>('default');

export function useApiSection(): ApiSection {
  return useContext(ApiSectionContext);
}
